function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#251619;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uB808\\uC774\\uC5B4_2",
  "data-name": "\\uB808\\uC774\\uC5B4 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uB808\\uC774\\uC5B4_1-2",
  "data-name": "\\uB808\\uC774\\uC5B4 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "30.36 12.7 30.36 8.82 15.88 0 0.41 8.8 30.29 28.5 30.36 28.38 30.36 24.58 12.97 13.11 15.65 11.54 30.36 20.75 30.36 16.84 15.71 7.66 9.89 11.08 6.75 9.01 15.82 3.84 30.36 12.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "0 11.56 0 15.36 17.39 26.82 14.71 28.4 0 19.19 0 23.1 14.65 32.28 20.47 28.85 23.61 30.93 14.54 36.09 0 27.24 0 31.12 14.49 39.93 29.95 31.13 0.08 11.44 0 11.56"
})));

function SvgOnlyshape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.36 39.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyshape);
export default __webpack_public_path__ + "static/media/onlyshape.98b7d9d6.svg";
export { ForwardRef as ReactComponent };